import { useState } from "react";
import { Link2, X } from "lucide-react";
import { Dialog, DialogContent } from "@/modern/components/ui/dialog-shadcn";
import { cn } from "@/modern/utils";
import { MarketingTag } from "@/bryntum-lib/models/MarketingTag";

export const ProblemContextButton = ({ tags, className }: { tags: MarketingTag[]; className?: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={cn(className)}>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="w-full flex items-center gap-3 px-1 py-2.5 text-left transition-colors hover:bg-muted/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-none"
        >
          <Link2 className="w-4 h-4 shrink-0 text-foreground/90" aria-hidden />
          <span className="flex-1 text-sm font-medium uppercase tracking-wide text-muted-foreground">
            Problem Context
          </span>
          <span className="inline-flex h-5 min-w-[1.5rem] items-center justify-center rounded-full px-2 text-xs font-medium tabular-nums bg-muted/80 text-muted-foreground border border-border/60">
            {tags.length}
          </span>
        </button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          showCloseButton={false}
          className="sm:max-w-lg p-0 gap-0 rounded-xl z-[--swivu-bryntum-z-index]"
        >
          <div className="flex items-center justify-between px-5 pt-5 pb-3">
            <div className="flex items-center gap-2.5">
              <Link2 className="w-5 h-5 text-foreground" />
              <h3 className="text-base font-semibold text-foreground">Problem Context</h3>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="h-7 w-7 rounded-full flex items-center justify-center border border-border hover:bg-muted transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          <p className="px-5 pb-4 text-sm text-muted-foreground leading-relaxed">
            Problem Context is automatically derived from your selected Solution Tags using the
            Cross-Walk Map. As you add or remove tags, the linked Problem Hubs update
            dynamically &mdash; no manual selection needed.
          </p>

          <div className="px-5 pb-5">
            <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3 block">
              Linked Problem Hubs
            </span>
            {tags.length > 0 ? (
              <div className="flex flex-wrap gap-1.5">
                {tags.map((tag) => (
                  <span
                    key={tag.id}
                    className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium border border-border bg-muted/30 text-foreground"
                  >
                    {tag.label}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-sm text-muted-foreground/70 italic">
                No problem hubs linked yet. Select solution tags to see linked problems.
              </p>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
